<template>
  <div :style="{ backgroundColor: note.color }">
    {{ note.msg }}
  </div>
</template>

<script>
export default {
  props: ['note'],
}
</script>

<style scoped>
div {
  position: fixed;
  width: 250px;
  min-height: 40px;
  margin: 20px;
  padding: 5px;
  justify-content: center;
  border: 2px solid grey;
  border-radius: 15px;
  font-size: 15;
  font-weight: bold;
}
</style>
